import { render } from "./MyCard.vue?vue&type=template&id=c9d09308&scoped=true&bindings={}"
import script from "./MyCard.vue?vue&type=script&lang=ts"
export * from "./MyCard.vue?vue&type=script&lang=ts"

import "./MyCard.vue?vue&type=style&index=0&id=c9d09308&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9d09308"

export default script